/**
 * @file Snackbar-related text
 */
import { __ } from '@@/bits/intl'
import { reload } from '@@/bits/location'
import type { GlobalSnackbarNotification } from '@@/pinia/global_snackbar'

const ACCESS_WITHDRAWN: GlobalSnackbarNotification = {
  message: __('You are not authorized to access this padlet anymore.'),
  actionText: __('Refresh'),
  actionTextActions: [() => reload()],
}

const SAVE_CHANGES_FAILED: GlobalSnackbarNotification = {
  message: __("Sorry, we couldn't save your changes. Please refresh the page."),
  actionText: __('Refresh'),
  actionTextActions: [() => reload()],
}

const NETWORK_SAVE_POST_FAILED: GlobalSnackbarNotification = {
  message: __('Couldn’t save your post. Please check your connection and try again.'),
  persist: true,
}

const FEATURE_FAILED_TO_LOAD: GlobalSnackbarNotification = {
  message: __('Sorry, we couldn’t load this. Please refresh the page.'),
  actionText: __('Refresh'),
  actionTextActions: [() => reload()],
}

const snackbarHelper = {
  ACCESS_WITHDRAWN,
  SAVE_CHANGES_FAILED,
  NETWORK_SAVE_POST_FAILED,
  FEATURE_FAILED_TO_LOAD,
}

export default snackbarHelper
export { ACCESS_WITHDRAWN, FEATURE_FAILED_TO_LOAD, NETWORK_SAVE_POST_FAILED, SAVE_CHANGES_FAILED }
